// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getRecentlyCompletedExams } from "../../api";
import { ExamType } from "../../types";

export const useRecentlyCompletedExamsData = (
  clinicId: string | undefined,
  payload: { recentFilterDate: string }
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<ExamType>>({
    queryKey: ["recent-exams", clinicId, payload],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getRecentlyCompletedExams(
        token,
        clinicId,
        payload,
        controller.signal
      );
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the dashboard
  });
};
